import React from "react";
import { useHistory, useLocation } from "react-router-dom";

const TABS = [
  { label: "Cotizaciones pendientes",     path: "/dashboard/cotizaciones"             },
  { label: "Solicitudes de cotizaciones", path: "/dashboard/cotizaciones/solicitudes" },
];

const CotizacionesNav = () => {
  const history  = useHistory();
  const location = useLocation();

  const isActive = (path) => {
    if (path === "/dashboard/cotizaciones") {
      // El tab "pendientes" es activo solo si la ruta es exactamente esa
      return location.pathname === "/dashboard/cotizaciones";
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div style={{
      maxWidth: 1100,
      margin: "0 auto 20px",
      display: "flex",
      gap: 4,
      borderBottom: "2px solid #f0e6ec",
    }}>
      {TABS.map((tab) => {
        const active = isActive(tab.path);
        return (
          <button
            key={tab.path}
            onClick={() => history.push(tab.path)}
            style={{
              padding: "10px 22px",
              background: "none",
              border: "none",
              borderBottom: active ? "2px solid #9f0059" : "2px solid transparent",
              marginBottom: -2,
              fontSize: 14,
              fontWeight: active ? 700 : 500,
              color: active ? "#9f0059" : "#888",
              cursor: "pointer",
              transition: "color 0.15s",
              whiteSpace: "nowrap",
            }}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default CotizacionesNav;
